import { useTranslation } from 'react-i18next';

const API = import.meta.env.VITE_API_URL ?? '';

/**
 * ReportsView — administration panel (monthly/yearly).
 * Contains: Betriebsspiegel, Analytics, DATEV, GoBD, Contracts.
 */
export default function ReportsView({ token, onCardTap }) {
  const { t } = useTranslation();

  const reports = [
    { id: 'betriebsspiegel', icon: '\uD83D\uDCCA', title: t('betriebsspiegel.title'), sub: t('reports.farmSummary'), downloadUrl: `${API}/api/v1/aif/reports/betriebsspiegel/pdf` },
    { id: 'analytics', icon: '\uD83D\uDCC8', title: t('analytics.title'), sub: t('reports.kpiTrends') },
    { id: 'compliance', icon: '\uD83D\uDD12', title: 'DATEV-Export', sub: t('reports.datevDesc'), downloadUrl: `${API}/api/v1/aif/compliance/datev-export?year=${new Date().getFullYear()}`, downloadName: 'csv' },
    { id: null, icon: '\u2705', title: t('reports.gobdTitle'), sub: t('reports.gobdDesc') },
    { id: 'contracts', icon: '\uD83D\uDCC4', title: t('contracts.title'), sub: t('reports.contractsDesc') },
    { id: 'procurement', icon: '\uD83D\uDCE6', title: t('procurement.title'), sub: t('reports.procurementDesc') },
  ];

  const handleDownload = async (url) => {
    try {
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) return;
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = url.includes('pdf') ? 'report.pdf' : 'export.csv';
      a.click();
    } catch { /* ignore */ }
  };

  return (
    <div className="h-full overflow-y-auto overscroll-contain">
      <div className="max-w-2xl mx-auto px-4 py-5 space-y-3">
        <h2 className="text-lg font-semibold text-[var(--aif-text-primary)] mb-2">{t('reports.title')}</h2>
        {reports.map((r, i) => (
          <button
            key={i}
            onClick={() => r.id ? onCardTap(r.id) : null}
            className="w-full text-left bg-[var(--aif-bg-surface)] border border-[var(--aif-border-default)] rounded-xl p-4 hover:bg-[var(--aif-bg-elevated)] transition flex items-center gap-3"
          >
            <span className="text-2xl flex-shrink-0">{r.icon}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[var(--aif-text-primary)]">{r.title}</div>
              <div className="text-xs text-[var(--aif-text-muted)]">{r.sub}</div>
            </div>
            {r.downloadUrl && (
              <button
                onClick={(e) => { e.stopPropagation(); handleDownload(r.downloadUrl); }}
                className="text-xs text-[var(--aif-color-primary)] font-medium flex-shrink-0"
              >
                {'\u2B07\uFE0F'}
              </button>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
